"use client";

import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@clerk/nextjs";
import { Effect } from "effect";
import { RpcClient } from "@effect/rpc";
import { featureAnnouncementsUserEq, FeatureAnnouncementsUserRpc } from "@/lib/effect-query";
export const FEEDBACK_ENABLED_QUERY_KEYS = {
  all: ["feedback-enabled"] as const,
  byKey: (feedbackKey: string) => [...FEEDBACK_ENABLED_QUERY_KEYS.all, feedbackKey] as const
};
const feedbackEnabledQueryOptions = (feedbackKey: string, enabled: boolean) => ({
  ...featureAnnouncementsUserEq.queryOptions({
    queryKey: FEEDBACK_ENABLED_QUERY_KEYS.byKey(feedbackKey),
    queryFn: () => Effect.gen(function* () {
      const client = yield* RpcClient.make(FeatureAnnouncementsUserRpc);
      return yield* client.isFeedbackEnabled({
        feedbackKey
      });
    }).pipe(Effect.scoped)
  }),
  staleTime: 5 * 60 * 1000,
  gcTime: 10 * 60 * 1000,
  enabled
});
export function useIsFeedbackEnabled(feedbackKey) {
  const $ = _c(6);
  const {
    isSignedIn
  } = useAuth();
  const t0 = feedbackKey ?? "";
  const t1 = !!feedbackKey && isSignedIn === true;
  let t2;
  if ($[0] !== t0 || $[1] !== t1) {
    t2 = feedbackEnabledQueryOptions(t0, t1);
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    data
  } = useQuery(t2);
  const t3 = data?.feedbackEnabled ?? false;
  const t4 = (data?.displayPosition ?? "floating") as "floating" | "top-bar" | "both";
  let t5;
  if ($[3] !== t3 || $[4] !== t4) {
    t5 = {
      feedbackEnabled: t3,
      feedbackDisplayMode: "modal" as "sidebar" | "modal",
      displayPosition: t4
    };
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
}